module.exports = __webpack_public_path__ + "static/media/practise.2b5b065c.svg";